import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
import Icon from '../../Icon';
import styles from './ProfileNav.module.sass';
import OutsideClickHandler from 'react-outside-click-handler';
import { UserContext } from '../../../contexts/UserContext';
import { ConquerContext } from '../../../contexts/ConquerContext';
import UserPhoto from '../../UserPhoto';

const ProfileNav = () => {
    const [isVisible, setIsVisible] = useState(false);

    const conquer = useContext( ConquerContext );
    const userContext = useContext( UserContext );

    const name = userContext.userData ? userContext.userData.firstName : '';

    function show() {
        setIsVisible(true);
    }

    function close() {
        setIsVisible(false);
    }

    return (
        <>
            <Link className={styles.avatarProfile} to={'/profile'}>
                <UserPhoto fallbackToMe={true}/>
            </Link>
            {/*<OutsideClickHandler onOutsideClick={close}>
                 {isVisible &&
                    <div className={styles.body}>
                        <div className={styles.name}>{name}</div>
                        <div className={styles.wrap}>
                            <Link to='/profile'>
                                <button
                                    className={cn(
                                        'button-stroke button-small',
                                        styles.button
                                    )}
                                    onClick={close}>
                                    My Profile
                                </button>
                            </Link>
                        </div>
                        <div className={styles.menu}>
                            <a
                                className={cn(styles.item, styles.disconnect)}
                                onClick={doLogout}>
                                <div className={styles.icon}>
                                    <Icon name='exit' size='20' />
                                </div>
                                <div className={styles.text} onClick={doLogout}>
                                    Log Out
                                </div>
                            </a>
                        </div>
                    </div>
                } 
            </OutsideClickHandler>*/}
        </>
    );
};

export default ProfileNav;
